import {
  CREATE_AGENT,
  CREATE_AGENT_SUCCESS,
  CREATE_AGENT_FAILURE,
  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAILURE,
  DELETE_AGENT,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAILURE,
  GET_AGENT,
  GET_AGENT_SUCCESS,
  GET_AGENT_FAILURE,
  INTERACT_WITH_AGENT,
  INTERACT_WITH_AGENT_SUCCESS,
  INTERACT_WITH_AGENT_FAILURE,
} from "../actions/agentActions";

const initialState = {
  agents: [], // List of all agents
  currentAgent: null, // Currently selected agent
  chatResponse: null, // Latest chat response
  loading: false, // Loading state
  error: null, // Error state
};

const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Loading states
    case CREATE_AGENT:
    case UPDATE_AGENT:
    case DELETE_AGENT:
    case GET_AGENT:
    case INTERACT_WITH_AGENT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Success states
    case CREATE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: [...state.agents, action.payload],
        currentAgent: action.payload,
        error: null,
      };

    case UPDATE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: state.agents.map((agent) =>
          agent.agentId === action.payload.agentId ? action.payload : agent
        ),
        currentAgent: action.payload,
        error: null,
      };

    case DELETE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: state.agents.filter(
          (agent) => agent.agentId !== action.payload.agentId
        ),
        currentAgent: null,
        error: null,
      };

    case GET_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentAgent: action.payload,
        error: null,
      };

    case INTERACT_WITH_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        chatResponse: action.payload.response,
        error: null,
      };

    // Failure states
    case CREATE_AGENT_FAILURE:
    case UPDATE_AGENT_FAILURE:
    case DELETE_AGENT_FAILURE:
    case GET_AGENT_FAILURE:
    case INTERACT_WITH_AGENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default agentReducer;
